// Include external scripts or styles as part of your content.
// These are utilities to dynamically add the external scripts & styles.
import React from 'react';
import { useLocation } from 'react-router-dom';

export const addExternalScripts = (arrScript, callback) => {
  if (arrScript.length === 0) {
    if (callback) callback();
    return;
  } else {
    const url = arrScript[0];
    const includes = document.head.querySelectorAll('script');
    includes.forEach((link) => {
      if (link.src.indexOf(url) !== -1) {
        link.parentNode.removeChild(link); // Remove existing
      }
    });
    const script = document.createElement('script');
    script.onload = () => {
      addExternalScripts(arrScript.slice(1), callback);
    };
    script.src = url;
    document.head.appendChild(script);
  }
};

export const addExternalStyles = (arrStyle) => {
  if (arrStyle.length === 0) {
    return;
  } else {
    let includes = document.head.querySelectorAll('[data-my-css-link]');
    includes.forEach((link) => {
      link.parentNode.removeChild(link); //Remove existing
    });
    for (let i = 0; i <= arrStyle.length - 1; i++) {
      let url = arrStyle[i];
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.setAttribute('data-my-css-link', '');
      link.href = url;
      document.head.appendChild(link);
    }
  }
};

export const renderHtml = (html) => {
  let range = document.createRange();
  const wrapper = document.querySelector('.is-wrapper');
  wrapper.innerHTML = '';
  wrapper.appendChild(range.createContextualFragment(html)); // We use createContextualFragment so that embedded javascript code (code block) will be executed
};

export const renderStyles = (mainCss, sectionCss) => {
  // Cleanup previously added styles (if any)

  // Remove sectionCss
  let links = document.querySelectorAll('[data-name="contentstyle"]');
  links.forEach((link) => {
    link.parentNode.removeChild(link);
  });

  // Remove mainCss
  links = document.getElementsByTagName('link');
  for (let i = 0; i < links.length; i++) {
    if (links[i].getAttribute('href').indexOf('basetype-') !== -1) {
      links[i].parentNode.removeChild(links[i]);
    }
  }

  if (mainCss)
    if (mainCss !== '') {
      document.head.insertAdjacentHTML('beforeend', mainCss); // add the style on the head
    }
  if (sectionCss)
    if (sectionCss !== '') {
      document.head.insertAdjacentHTML('beforeend', sectionCss); // add the style on the head
    }
};

export function useQuery() {
  const location = useLocation();

  return React.useMemo(() => new URLSearchParams(location?.search), [location]);
}

export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url?.replace(/-/g, '+')?.replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
};

export const logger = (() => {
  const print = (type, ...messages) => {
    switch (type) {
      case 'info':
        console.info('[INFO]', ...messages);
        break;
      case 'warn':
        console.warn('[WARN]', ...messages);
        break;
      case 'error':
        console.error('[ERROR]', ...messages);
        break;
      case 'trace':
        console.trace('[TRACE]', ...messages);
        break;
      case 'debug':
      default:
        console.log('[DEBUG]', ...messages);
    }
  };

  return {
    debug: print.bind(null, 'debug'),
    info: print.bind(null, 'info'),
    warn: print.bind(null, 'warn'),
    error: print.bind(null, 'error'),
    trace: print.bind(null, 'trace'),
  };
})();

export const slugRegex = /^[A-Za-z0-9]+(?:[_-][A-Za-z0-9]+)*$/;

/**
 * Removes URL parameters
 * @param removeParams - param array
 */
export function removeURLParameters(removeParams) {
  const deleteRegex = new RegExp(removeParams.join('=|') + '=');

  const params = location.search.slice(1).split('&');
  let search = [];
  for (let i = 0; i < params.length; i++)
    if (deleteRegex.test(params[i]) === false) search.push(params[i]);

  window.history.replaceState(
    {},
    document.title,
    location.pathname +
      (search.length ? '?' + search.join('&') : '') +
      location.hash
  );
}
